export default function(location) {
  if (typeof location === "undefined" || !location) return null;
  if (typeof location.prefecture === "undefined" || !location.prefecture) return null;
  return `${location.prefecture.attributes?.name}${location.municipality}${location.address}${location.building_name}`;
}
